module.exports = __webpack_public_path__ + "static/media/send.494ba592.svg";